import React, { useContext, useState } from "react";

// Material UI stuff
import RssFeedIcon from "@material-ui/icons/RssFeed";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

//components
import DisplayConnectedWeaviateModal from "./GeneralModal";

// Styling
import "../../Styles/MainPage.scss";

// Global state
import { StateContext } from "../../AppStateContext";

const WeaviateStateDisplay = ({ isWeaviateConnected }) => {
  //to access global state
  const state = useContext(StateContext);

  //state to control connected Weaviate modal
  const [showConnectedWeaviate, setShowConnectedWeaviate] = useState(false);

  const closeModal = () => {
    setShowConnectedWeaviate(false);
  };

  if (state.connectToWeaviateURI === "" || !isWeaviateConnected) {
    return (
      <>
        <Tooltip
          title="Not connected to a Weaviate instance"
          placement="bottom"
        >
          <RssFeedIcon id="weaviateStateDisconnectedIcon" />
        </Tooltip>
      </>
    );
  } else if (isWeaviateConnected && state.connectToWeaviateURI !== "") {
    return (
      <>
        <IconButton onClick={() => setShowConnectedWeaviate(true)}>
          <Tooltip title="Connected. Click to check out the running instance">
            <RssFeedIcon
              id="weaviateStateConnectedIcon"
              style={{ fontSize: "26px" }}
            />
          </Tooltip>
        </IconButton>
        <DisplayConnectedWeaviateModal
          title="Weaviate Instance"
          text="Your current instance is running at:"
          modalDescription="Weaviate currently running modal dialog"
          actionText="Close"
          actionFunction={closeModal}
          open={showConnectedWeaviate}
          inputValue={state.connectToWeaviateURI}
          closeModal={closeModal}
          actionButtonId="closeDisplayConnectedWeaviateModal"
          id="showConnectedWeaviateModal"
        />
      </>
    );
  }
};

export default WeaviateStateDisplay;
